<template>
    <footer class="footer">
        <div class="container">
            <div class="row align-items-center">
                <span class="company col-5 col-lg-8">&copy; SwissMarine Pte Ltd</span>
                <span class="policy-link align-items-center">
                    <a v-on:click="$emit('toggleShipRecycling', $event)" href="#" class="col-5 col-lg-3">Ship
                        recycling policy</a>
                </span>
                <span class="policy-link align-items-right">
                    <a v-on:click="$emit('togglePolicy', $event)" href="#" class="col-2 col-lg-1">Policy</a>
                </span>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style scoped>
.footer {
    position: fixed;
    height: 80px;
    bottom: 0;
    width: 100%;
    z-index: 1003;
}

@media (max-width: 490px) {
    .footer {
        height: 120px;
    }

    .footer .company {
        max-width: 100%;
        flex: 0 0 100%;
        padding-top: 24px;
        padding-bottom: 24px;
    }
}

.footer,
.footer a {
    background-color: #0A2739;
    color: #FFF;
}

.footer .company {
    opacity: 0.6;
}

.footer .row {
    height: 5em;
    justify-content: space-between;
}
</style>